// HOME_ 1
export const TITLE_PINK_IMG = require('./Home/Map1/backgroundHeader.webp');
export const ICON = require("./icon.webp")
